// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27HKQ","largestCol":"styles_largestCol__13WHq","smallestCol":"styles_smallestCol__d-5Hl"};